import React, { FormEvent, useEffect, useState, useCallback } from "react";
import "./PanierMagasinMobile.css";
import SideBarMagasinMobile from "../SideBareMagasin/SidebarMagasinMobile";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PanierLengVisiteur from "../../../Services/Panier/PanierLeng";
import AfficheMagasinsService from "../../../Services/Magasin/AfficheMagasinsService";
import { MagasinInfo } from "../../../Modeles/MagasinModel";
import DefaulteImage from "../../Utilisateure/visiteur/DefaulteImage.jpeg";

interface SocieteLivraison {
  id: number;
  NomSociete: string;
  AdresseSociete: string;
  Prix: string;
  Status: string;
  Date: string;
}

interface Product {
  id: any;
  IdArticle: any;
  Designation: string;
  Image: string;
  price: string;
  quantity: number;
  Remise: any;
  NomMagasin: any;
  RefArticle?: string;
}

interface EnCompteInfo {
  en_compte: boolean;
  solde: number;
  entry_id: number | null;
  seller_id: number | null;
  seller_name: string;
}

interface SubOrder {
  sellerName: string;
  items: Product[];
  total: number;
  enCompte: EnCompteInfo | null;
  paymentMethod: "solde" | "rib";
}

function itemTotal(p: Product): number {
  const unit = Number(String(p.price).replace(",", ".")) || 0;
  return unit * Number(p.quantity);
}

function groupByMagasin(items: Product[]): Record<string, Product[]> {
  return items.reduce<Record<string, Product[]>>((acc, item) => {
    const key = (item.NomMagasin || "").trim() || "Inconnu";
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});
}

const PanierMagasinMobile = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [subtotal, setSubtotal] = useState<number>(0);
  const [PopUp, setPopUp] = useState<boolean>(false);
  const [ShowSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [deletingId, setDeletingId] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [progressMsg, setProgressMsg] = useState<string>("Enregistrement de la commande...");

  const [subOrders, setSubOrders] = useState<SubOrder[]>([]);
  const [loadingEnCompte, setLoadingEnCompte] = useState(false);

  const handleGoBack = () => window.history.back();

  const MagasinId   = localStorage.getItem('MagasinId') ?? '';
  const MagasinName = localStorage.getItem('MagasinName') ?? '';
  const adresse     = localStorage.getItem('adresse') ?? '';

  /* ── Delivery form state ── */
  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [orderNom, setOrderNom]       = useState(MagasinName);
  const [orderAdresse, setOrderAdresse] = useState(adresse);
  const [modeLivraison, setModeLivraison] = useState<'magasin' | 'societe'>('magasin');
  const [selectedMagasinId, setSelectedMagasinId] = useState<any>(null);
  const [allMagasins, setAllMagasins] = useState<MagasinInfo[]>([]);
  const [loadingMagasins, setLoadingMagasins] = useState(false);
  const [formErrors, setFormErrors] = useState<{nom?:string; adresse?:string; magasin?:string; societe?:string}>({});
  const [societes, setSocietes] = useState<SocieteLivraison[]>([]);
  const [selectedSociete, setSelectedSociete] = useState<SocieteLivraison | null>(null);
  const [loadingSocietes, setLoadingSocietes] = useState(false);

  // Fetch cart
  const fetchPanier = () => {
    setLoading(true);
    PanierLengVisiteur(MagasinId, "magasins")
      .GetLenPanier()
      .then((response: any) => setProducts(response.data))
      .catch((error: any) => console.error("Error fetching panier:", error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPanier();
  }, []);

  /* ── Fetch magasins for pickup ── */
  useEffect(() => {
    setLoadingMagasins(true);
    AfficheMagasinsService()
      .getMagasin()
      .then((res) => {
        const filtered = res.data.filter(
          (mag: MagasinInfo) => mag.NomMagasin !== MagasinName
        );
        setAllMagasins(filtered);
      })
      .catch(console.error)
      .finally(() => setLoadingMagasins(false));
  }, [MagasinName]);

  /* ── Fetch sociétés de livraison ── */
  useEffect(() => {
    setLoadingSocietes(true);
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/societe-livraison`)
      .then(({ data }) => {
        const active = data.filter((s: SocieteLivraison) => s.Status === 'active');
        setSocietes(active);
      })
      .catch(console.error)
      .finally(() => setLoadingSocietes(false));
  }, []);

  useEffect(() => {
    const total = products.reduce((acc, p) => acc + itemTotal(p), 0);
    setSubtotal(parseFloat(total.toFixed(2)));
  }, [products]);

  /* ── Group into sub-orders ── */
  useEffect(() => {
    const grouped = groupByMagasin(products);
    const orders: SubOrder[] = Object.entries(grouped).map(([seller, items]) => ({
      sellerName: seller,
      items,
      total: parseFloat(items.reduce((s, i) => s + itemTotal(i), 0).toFixed(2)),
      enCompte: null,
      paymentMethod: "rib",
    }));
    setSubOrders(orders);
  }, [products]);

  /* ── Load en-compte info for modal ── */
  const loadEnCompte = useCallback(async (orders: SubOrder[]) => {
    if (!MagasinId || orders.length === 0) return;
    setLoadingEnCompte(true);
    const updated = await Promise.all(
      orders.map(async (o) => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/en-compte-by-supplier`,
            { params: { seller_name: o.sellerName } }
          );
          const info: EnCompteInfo = res.data;
          return {
            ...o,
            enCompte: info,
            paymentMethod: (info.en_compte && info.solde >= o.total ? "solde" : "rib") as "solde" | "rib",
          };
        } catch {
          return { ...o, enCompte: { en_compte: false, solde: 0, entry_id: null, seller_id: null, seller_name: o.sellerName }, paymentMethod: "rib" as "solde" | "rib" };
        }
      })
    );
    setSubOrders(updated);
    setLoadingEnCompte(false);
  }, [MagasinId]);

  const handleOpenDeliveryModal = async () => {
    setShowDeliveryModal(true);
    await loadEnCompte(subOrders);
  };

  const handleDelete = async (id: any) => {
    setDeletingId(id);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete`, { id });
      setProducts(prev => prev.filter((item) => item.id !== id));
    } catch (err) {
      console.error(err);
    } finally {
      setDeletingId(null);
    }
  };

  const handleQtyChange = async (id: any, delta: number) => {
    const item = products.find(p => p.id === id);
    if (!item) return;
    const newQty = Math.max(1, item.quantity + delta);
    setProducts(prev => prev.map(p => p.id === id ? { ...p, quantity: newQty } : p));
    try {
      const fd = new FormData();
      fd.append("quantity", newQty.toString());
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/update/${id}`, fd);
    } catch {
      setProducts(prev => prev.map(p => p.id === id ? { ...p, quantity: item.quantity } : p));
    }
  };

  const handleClearCart = () => setPopUp(true);
  const closePopup = () => setPopUp(false);
  const VidePanier = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete/all/${MagasinId}`);
      setProducts([]);
    } catch (err) {
      console.error(err);
    }
    setPopUp(false);
  };
  const navigate = useNavigate();

  const currentFrais = modeLivraison === 'magasin' 
    ? 0 
    : (selectedSociete ? (selectedSociete.Prix === '-' ? 0 : parseFloat(selectedSociete.Prix || '0')) : 0);

  const total = subtotal + currentFrais;

  const validateDeliveryForm = (): boolean => {
    const errors: {nom?:string; adresse?:string; magasin?:string; societe?:string} = {};
    if (!orderNom.trim()) errors.nom = 'Champ requis';
    if (!orderAdresse.trim()) errors.adresse = 'Champ requis';
    if (modeLivraison === 'magasin' && !selectedMagasinId) errors.magasin = 'Choisissez un magasin';
    if (modeLivraison === 'societe' && !selectedSociete) errors.societe = 'Choisissez une société';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e?: FormEvent) => {
    if (e) e.preventDefault();
    if (!validateDeliveryForm()) return;
    setSubmitting(true);
    setShowDeliveryModal(false);

    const selectedMag = allMagasins.find(m => m.IdMagasin === selectedMagasinId);

    try {
      const totalOrdersCount = subOrders.length;
      for (let i = 0; i < subOrders.length; i++) {
        const sub = subOrders[i];
        const orderIndexLabel = totalOrdersCount > 1 ? `[${i + 1}/${totalOrdersCount}] ` : "";
        const subTotal = sub.total;
        const subFrais = totalOrdersCount === 1 ? currentFrais : 0;
        const subTotalTTC = parseFloat((subTotal + subFrais).toFixed(2));

        let methodPayment = "A la livraison";
        let statutPayment = "en cours..";
        if (sub.paymentMethod === "solde" && sub.enCompte?.en_compte) {
          methodPayment = "Solde en compte";
          statutPayment = "Payé par solde";
        }

        const formData = new FormData();
        formData.append("adress", orderAdresse);
        formData.append("NomClient", orderNom);
        formData.append("SousClient", "");
        formData.append("Remarque", "");
        formData.append("TotalHT", subTotal.toString());
        formData.append("TotalTTC", subTotalTTC.toString());
        formData.append("NomMagasin", MagasinName || "");
        formData.append("IdMagasin", MagasinId || "");
        formData.append("TypeUtilisateur", "magasin");
        formData.append("ModeLivraison", modeLivraison);
        formData.append("FraisLivraison", subFrais.toString());
        formData.append("MagasinRetrait", modeLivraison === 'magasin' && selectedMag ? selectedMag.NomMagasin : selectedSociete ? selectedSociete.NomSociete : 'Société de livraison');
        formData.append("AdresseRetreit", modeLivraison === 'magasin' && selectedMag ? selectedMag.adresse_de_siege : selectedSociete ? selectedSociete.AdresseSociete : '');
        formData.append("SocieteLivraison", modeLivraison === 'societe' && selectedSociete ? selectedSociete.NomSociete : '');
        formData.append("MethodPayment", methodPayment);
        formData.append("StatutPayment", statutPayment);
        // Pass entry_id so the backend can verify solde before creating the order
        if (sub.paymentMethod === "solde" && sub.enCompte?.entry_id) {
          formData.append("entry_id", String(sub.enCompte.entry_id));
        }

        sub.items.forEach((item: any, index: number) => {
          for (const key in item) {
            if (Object.prototype.hasOwnProperty.call(item, key)) {
              const value = String(item[key]).replace(",", ".");
              formData.append(`detail[${index}][${key}]`, value);
            }
          }
        });

        // 1️⃣ Enregistrer la commande
        setProgressMsg(`${orderIndexLabel}Enregistrement de la commande pour "${sub.sellerName}"...`);
        const response = await axios.post(
          `${process.env.REACT_APP_PHP_APP_URL}/enregistrerCommande`,
          formData
        );

        // 2️⃣ Envoyer les articles liés à la commande
        setProgressMsg(`${orderIndexLabel}Envoi des ${sub.items.length} articles (BL: ${response.data.IdBl})...`);
        await axios.post(
          `${process.env.REACT_APP_PHP_APP_URL}/sendArticleCommande/${response.data.IdBl}`,
          { DataTable: sub.items },
          { headers: { "Content-Type": "application/json" } }
        );

        // 3️⃣ Déduire solde if payment by solde
        if (sub.paymentMethod === "solde" && sub.enCompte?.en_compte && sub.enCompte.entry_id) {
          try {
            setProgressMsg(`${orderIndexLabel}Déduction du solde en compte (${subTotal} MAD)...`);
            const soldeResp = await axios.post(
              `${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/pay-by-solde`,
              { entry_id: sub.enCompte.entry_id, amount: subTotal }
            );
            // ✅ Real-time: update localStorage solde so the banner shows correct balance
            if (soldeResp.data?.new_solde !== undefined) {
              localStorage.setItem('en_compte_solde', String(soldeResp.data.new_solde));
            }
          } catch (soldeErr) {
            console.error("Erreur déduction solde:", soldeErr);
          }
        }
      }

      // 4️⃣ Vider le panier dans la base de données
      setProgressMsg("Finalisation et vidage du panier...");
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete/all/${MagasinId}`);
      localStorage.removeItem("cartExpiration");
      window.dispatchEvent(new Event("panier-updated"));

      // 5️⃣ Popup succès + redirection
      setShowSuccessPopup(true);

      const timeoutId = setTimeout(() => {
        setShowSuccessPopup(false);
        navigate(`/magasins/${MagasinId}`);
      }, 2000);

      return () => clearTimeout(timeoutId);
    } catch (error: any) {
      console.error("Erreur lors de l'envoi de la commande:", error);
      const serverMsg = error?.response?.data?.message || "Une erreur est survenue lors de l'enregistrement de la commande.";
      setErrorMessage(serverMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <SideBarMagasinMobile/>
      <div className="pmm-container">

        {/* ── Success Overlay ── */}
        {ShowSuccessPopup && (
          <div className="pmm-overlay">
            <div className="pmm-modal pmm-modal--success">
              <div className="pmm-modal__icon-wrap pmm-modal__icon-wrap--success">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h3 className="pmm-modal__title">Commande confirmée !</h3>
              <p className="pmm-modal__desc">Votre commande a été effectuée avec succès. Veuillez patienter pour le traitement.</p>
              <div className="pmm-modal__loader-bar"/>
            </div>
          </div>
        )}

        {/* ── Error Overlay (e.g. Solde Insuffisant) ── */}
        {errorMessage && (
          <div className="pmm-overlay" onClick={() => setErrorMessage(null)}>
            <div className="pmm-modal pmm-modal--error" style={{ maxWidth: 360, textAlign: "center" }}>
              <div className="pmm-modal__icon-wrap pmm-modal__icon-wrap--danger">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
              </div>
              <h3 className="pmm-modal__title" style={{ color: "#dc2626" }}>Erreur de commande</h3>
              <p className="pmm-modal__desc" style={{ color: "#374151", fontSize: "14px", lineHeight: "1.5" }}>{errorMessage}</p>
              <div className="pmm-modal__actions" style={{ marginTop: 18 }}>
                <button onClick={() => setErrorMessage(null)} className="pmm-modal__btn pmm-modal__btn--cancel" style={{ width: "100%", padding: "12px" }}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Clear Cart Confirmation ── */}
        {PopUp && (
          <div className="pmm-overlay" onClick={(e) => e.target === e.currentTarget && closePopup()}>
            <div className="pmm-modal">
              <div className="pmm-modal__icon-wrap pmm-modal__icon-wrap--danger">
                <svg width="32" height="32" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
              </div>
              <h3 className="pmm-modal__title">Vider le panier ?</h3>
              <p className="pmm-modal__desc">Cette action supprimera tous les articles de votre panier. Elle est irréversible.</p>
              <div className="pmm-modal__actions">
                <button onClick={closePopup} className="pmm-modal__btn pmm-modal__btn--cancel">Annuler</button>
                <button onClick={VidePanier} className="pmm-modal__btn pmm-modal__btn--danger">Oui, vider</button>
              </div>
            </div>
          </div>
        )}

        {/* ── Header ── */}
        <div className="pmm-header">
          <button className="pmm-header__back" onClick={handleGoBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>
          <div className="pmm-header__center">
            <h1 className="pmm-header__title">Mon Panier</h1>
            {products.length > 0 && (
              <span className="pmm-header__badge">{products.length}</span>
            )}
          </div>
          {products.length > 0 && (
            <button className="pmm-header__clear" onClick={handleClearCart}>
              <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
              </svg>
            </button>
          )}
        </div>

        {/* ── Content ── */}
        {loading ? (
          <div className="pmm-empty">
            <div className="pmm-empty__illustration">
              <div className="pmm-empty__circle"/>
            </div>
            <h3 className="pmm-empty__title">Chargement…</h3>
          </div>
        ) : products.length > 0 ? (
          <>
            {/* Product cards grouped by seller */}
            <div className="pmm-list">
              {subOrders.map((sub) => (
                <div key={sub.sellerName} style={{ marginBottom: 20 }}>
                  <div style={{
                    display: "flex", alignItems: "center", gap: 6,
                    padding: "6px 8px", marginBottom: 8,
                    background: "#fef3c7", borderRadius: 8,
                    fontSize: 13, fontWeight: 700, color: "#92400e"
                  }}>
                    🏪 {sub.sellerName} ({sub.items.length} art.) — {sub.total.toLocaleString("fr-MA")} MAD
                  </div>
                  {sub.items.map((product, index) => (
                    <div
                      key={product.id}
                      className={`pmm-card ${deletingId === product.id ? 'pmm-card--deleting' : ''}`}
                      style={{ animationDelay: `${index * 50}ms` }}
                    >
                      <div className="pmm-card__img-wrap">
                        <img
                          src={product.Image || DefaulteImage}
                          alt={product.Designation}
                          className="pmm-card__img"
                          onError={(e) => { (e.target as HTMLImageElement).src = DefaulteImage; }}
                        />
                      </div>
                      <div className="pmm-card__body">
                        <div className="pmm-card__top">
                          <h4 className="pmm-card__name">{product.Designation}</h4>
                          <button
                            onClick={() => handleDelete(product.id)}
                            className="pmm-card__del"
                          >
                            <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                          </button>
                        </div>
                        <div className="pmm-card__bottom">
                          <div className="pmm-qty">
                            <button className="pmm-qty__btn" onClick={() => handleQtyChange(product.id, -1)}>−</button>
                            <span className="pmm-qty__val">{product.quantity}</span>
                            <button className="pmm-qty__btn" onClick={() => handleQtyChange(product.id, 1)}>+</button>
                          </div>
                          <div className="pmm-card__price">
                            {itemTotal(product).toLocaleString("fr-MA")} MAD
                          </div>
                        </div>
                        {product.quantity > 1 && (
                          <span className="pmm-card__unit">
                            {(Number(String(product.price).replace(",", ".")) || 0).toLocaleString("fr-MA")} MAD / unité
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            {/* ── Summary ── */}
            <div className="pmm-summary">
              <div className="pmm-summary__header">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 5H2v7l6.29 6.29c.94.94 2.48.94 3.42 0l4.58-4.58c.94-.94.94-2.48 0-3.42L9 5z"/>
                  <path d="M6 9.01V9"/>
                </svg>
                <span>Récapitulatif</span>
              </div>
              <div className="pmm-summary__rows">
                {subOrders.map(sub => (
                  <div className="pmm-summary__row" key={sub.sellerName}>
                    <span>{sub.sellerName}</span>
                    <span className="pmm-summary__val">{sub.total.toLocaleString("fr-MA")} MAD</span>
                  </div>
                ))}
                {modeLivraison !== 'magasin' && (
                  <div className="pmm-summary__row">
                    <span>Frais de livraison</span>
                    <span className="pmm-summary__val">{currentFrais.toLocaleString("fr-MA")} MAD</span>
                  </div>
                )}
                <div className="pmm-summary__divider"/>
                <div className="pmm-summary__row pmm-summary__row--total">
                  <span>Total</span>
                  <span>{total.toLocaleString("fr-MA")} MAD</span>
                </div>
                {subOrders.length > 1 && (
                  <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4, textAlign: "center" }}>
                    → Divisé en {subOrders.length} sous-commandes
                  </div>
                )}
              </div>
            </div>

            {/* ── Sticky checkout button ── */}
            <div className="pmm-checkout-bar">
              <div className="pmm-checkout-bar__info">
                <span className="pmm-checkout-bar__label">Total</span>
                <span className="pmm-checkout-bar__amount">{total.toLocaleString("fr-MA")} MAD</span>
              </div>
              <button className="pmm-checkout-bar__btn" onClick={handleOpenDeliveryModal} disabled={submitting}>
                {submitting ? (
                  <><span className="pm-spinner" style={{width:16,height:16,borderWidth:2,borderColor:'rgba(255,255,255,0.3)',borderTopColor:'#fff'}} /> Envoi...</>
                ) : (
                  <>Commander
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14"/>
                    <polyline points="12 5 19 12 12 19"/>
                  </svg></>
                )}
              </button>
            </div>

            {/* ── Delivery Modal (bottom sheet) ── */}
            {showDeliveryModal && (
              <div className="pmm-overlay" onClick={(e) => e.target === e.currentTarget && setShowDeliveryModal(false)}>
                <div className="pmm-modal pmm-modal--delivery" style={{ maxHeight: "88vh", overflowY: "auto" }}>
                  <div className="pmm-modal__handle" />
                  <div className="pmm-modal__header-row">
                    <div>
                      <h3 className="pmm-modal__title">Informations de livraison</h3>
                      <p className="pmm-modal__desc">Remplissez vos coordonnées pour finaliser</p>
                    </div>
                    <button
                      type="button"
                      className="pmm-modal__close-btn"
                      onClick={() => setShowDeliveryModal(false)}
                      aria-label="Fermer"
                    >
                      ✕
                    </button>
                  </div>

                  {/* Nom */}
                  <div className="pmm-field">
                    <label className="pmm-field__label">Nom complet</label>
                    <div className="pmm-field__wrap">
                      <svg className="pmm-field__icon" viewBox="0 0 16 16" fill="currentColor" width="14" height="14"><path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/></svg>
                      <input className={`pmm-field__input${formErrors.nom ? ' pmm-field__input--error' : ''}`} type="text" placeholder="ex : Ahmed Benali" value={orderNom} onChange={(e) => { setOrderNom(e.target.value); setFormErrors(p => ({...p, nom: undefined})); }} />
                    </div>
                    {formErrors.nom && <span className="pmm-field__error">{formErrors.nom}</span>}
                  </div>

                  {/* Adresse */}
                  <div className="pmm-field">
                    <label className="pmm-field__label">Adresse</label>
                    <div className="pmm-field__wrap">
                      <svg className="pmm-field__icon" viewBox="0 0 16 16" fill="currentColor" width="14" height="14"><path fillRule="evenodd" d="M8 1a4.5 4.5 0 0 0-4.5 4.5c0 3.09 4.5 8.5 4.5 8.5s4.5-5.41 4.5-8.5A4.5 4.5 0 0 0 8 1zm0 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>
                      <input className={`pmm-field__input${formErrors.adresse ? ' pmm-field__input--error' : ''}`} type="text" placeholder="ex : 12 Rue Mohammed V" value={orderAdresse} onChange={(e) => { setOrderAdresse(e.target.value); setFormErrors(p => ({...p, adresse: undefined})); }} />
                    </div>
                    {formErrors.adresse && <span className="pmm-field__error">{formErrors.adresse}</span>}
                  </div>

                  {/* Mode de livraison */}
                  <div className="pmm-field">
                    <label className="pmm-field__label">Mode de livraison</label>
                    <div className="pmm-livraison-grid">
                      <button type="button" className={`pmm-livraison-opt${modeLivraison === 'magasin' ? ' pmm-livraison-opt--active' : ''}`} onClick={() => { setModeLivraison('magasin'); setSelectedMagasinId(null); }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="24" height="24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                        <span className="pmm-livraison-opt__label">Magasin</span>
                        <span className="pmm-livraison-opt__sub">Retrait</span>
                        {modeLivraison === 'magasin' && <span className="pmm-livraison-opt__check">✓</span>}
                      </button>
                      <button type="button" className={`pmm-livraison-opt${modeLivraison === 'societe' ? ' pmm-livraison-opt--active' : ''}`} onClick={() => { setModeLivraison('societe'); setSelectedMagasinId(null); }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="24" height="24"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                        <span className="pmm-livraison-opt__label">Société</span>
                        <span className="pmm-livraison-opt__sub">Livraison</span>
                        {modeLivraison === 'societe' && <span className="pmm-livraison-opt__check">✓</span>}
                      </button>
                    </div>
                  </div>

                  {/* Magasin picker */}
                  {modeLivraison === 'magasin' && (
                    <div className="pmm-field">
                      <label className="pmm-field__label">Magasin de retrait</label>
                      {loadingMagasins ? (
                        <div className="pmm-magasin-loading"><span className="pm-spinner" style={{width:14,height:14,borderWidth:2,borderColor:'rgba(0,0,0,0.1)',borderTopColor:'var(--pmm-gold)'}} /> Chargement…</div>
                      ) : allMagasins.length === 0 ? (
                        <p style={{fontSize:13,color:'var(--pmm-gray-500)',margin:0}}>Aucun magasin disponible.</p>
                      ) : (
                        <div className="pmm-magasin-list">
                          {allMagasins.map((mag) => (
                            <button key={mag.IdMagasin} type="button" className={`pmm-magasin-card${selectedMagasinId === mag.IdMagasin ? ' pmm-magasin-card--active' : ''}`} onClick={() => { setSelectedMagasinId(mag.IdMagasin); setFormErrors(p => ({...p, magasin: undefined})); }}>
                              <div className="pmm-magasin-card__icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="18" height="18"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                              </div>
                              <div className="pmm-magasin-card__info">
                                <span className="pmm-magasin-card__name">{mag.NomMagasin}</span>
                                <span className="pmm-magasin-card__addr">{mag.adresse_de_siege}</span>
                              </div>
                              {selectedMagasinId === mag.IdMagasin && <span className="pmm-magasin-card__check">✓</span>}
                            </button>
                          ))}
                        </div>
                      )}
                      {formErrors.magasin && <span className="pmm-field__error">{formErrors.magasin}</span>}
                    </div>
                  )}

                  {/* Société de livraison picker */}
                  {modeLivraison === 'societe' && (
                    <div className="pmm-field">
                      <label className="pmm-field__label">Société de livraison</label>
                      {loadingSocietes ? (
                        <div className="pmm-magasin-loading"><span className="pm-spinner" style={{width:14,height:14,borderWidth:2,borderColor:'rgba(0,0,0,0.1)',borderTopColor:'var(--pmm-gold)'}} /> Chargement…</div>
                      ) : societes.length === 0 ? (
                        <p style={{fontSize:13,color:'var(--pmm-gray-500)',margin:0}}>Aucune société disponible.</p>
                      ) : (
                        <div className="pmm-magasin-list">
                          {societes.map((soc) => (
                            <button key={soc.id} type="button" className={`pmm-magasin-card${selectedSociete?.id === soc.id ? ' pmm-magasin-card--active' : ''}`} onClick={() => { setSelectedSociete(soc); setFormErrors(p => ({...p, societe: undefined})); }}>
                              <div className="pmm-magasin-card__icon" style={{color: '#16a34a'}}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="18" height="18"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                              </div>
                              <div className="pmm-magasin-card__info">
                                <span className="pmm-magasin-card__name">{soc.NomSociete}</span>
                                <span className="pmm-magasin-card__addr">{soc.AdresseSociete}</span>
                                <span style={{fontSize:11,fontWeight:600,color:'#16a34a',marginTop:2}}>{parseFloat(soc.Prix).toFixed(2)} MAD</span>
                              </div>
                              {selectedSociete?.id === soc.id && <span className="pmm-magasin-card__check">✓</span>}
                            </button>
                          ))}
                        </div>
                      )}
                      {formErrors.societe && <span className="pmm-field__error">{formErrors.societe}</span>}
                    </div>
                  )}

                  {/* Per-seller payment method — Premium Design */}
                  <div className="pmm-field" style={{ marginTop: 16 }}>
                    <label className="pmm-field__label" style={{
                      fontWeight: 800, fontSize: 11, textTransform: 'uppercase',
                      letterSpacing: '0.6px', color: '#374151', marginBottom: 12, display: 'flex',
                      alignItems: 'center', gap: 6
                    }}>
                      <span style={{ fontSize: 14 }}>💳</span> Mode de paiement
                    </label>
                    {loadingEnCompte ? (
                      <div className="pmm-magasin-loading" style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        padding: '14px 16px', borderRadius: 14, background: '#f9fafb',
                        border: '1px solid #e5e7eb'
                      }}>
                        <span className="pm-spinner" style={{width:14,height:14,borderWidth:2,borderColor:'rgba(0,0,0,0.1)',borderTopColor:'#6366f1'}} />
                        <span style={{ fontSize: 13, color: '#6b7280' }}>Vérification en-compte…</span>
                      </div>
                    ) : (
                      subOrders.map((sub, idx) => {
                        const ec = sub.enCompte;
                        const canUseSolde = ec?.en_compte && ec.solde >= sub.total;
                        const soldeLow = ec?.en_compte && ec.solde > 0 && ec.solde < sub.total;
                        const isSolde = sub.paymentMethod === "solde";
                        const isRib = sub.paymentMethod === "rib";
                        return (
                          <div key={sub.sellerName} style={{
                            borderRadius: 16,
                            marginBottom: 12,
                            overflow: 'hidden',
                            border: isSolde ? '2px solid #16a34a' : isRib ? '2px solid #f59e0b' : '1.5px solid #e5e7eb',
                            boxShadow: isSolde
                              ? '0 4px 16px rgba(22,163,74,0.15)'
                              : isRib
                                ? '0 4px 16px rgba(245,158,11,0.12)'
                                : '0 2px 8px rgba(0,0,0,0.05)',
                            transition: 'all 0.25s ease',
                          }}>
                            {/* Card Header */}
                            <div style={{
                              padding: '12px 14px',
                              background: isSolde
                                ? 'linear-gradient(135deg,#f0fdf4,#dcfce7)'
                                : isRib
                                  ? 'linear-gradient(135deg,#fffbeb,#fef3c7)'
                                  : 'linear-gradient(135deg,#f9fafb,#f3f4f6)',
                              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                              borderBottom: '1px solid rgba(0,0,0,0.06)',
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{
                                  width: 34, height: 34, borderRadius: 10,
                                  background: isSolde ? '#bbf7d0' : isRib ? '#fde68a' : '#e5e7eb',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  fontSize: 16,
                                }}>🏪</div>
                                <div>
                                  <div style={{ fontWeight: 800, fontSize: 13, color: '#111' }}>{sub.sellerName}</div>
                                  <div style={{ fontSize: 10, color: '#9ca3af', fontWeight: 500 }}>Fournisseur</div>
                                </div>
                              </div>
                              <div style={{
                                fontWeight: 800, fontSize: 13,
                                color: isSolde ? '#15803d' : isRib ? '#92400e' : '#374151',
                                background: isSolde ? '#dcfce7' : isRib ? '#fef3c7' : '#e5e7eb',
                                padding: '4px 10px', borderRadius: 20,
                              }}>
                                {sub.total.toLocaleString('fr-MA')} MAD
                              </div>
                            </div>

                            {/* En-Compte Status */}
                            <div style={{ padding: '10px 14px 0', background: '#fff' }}>
                              {ec?.en_compte ? (
                                <div style={{
                                  display: 'flex', alignItems: 'center', gap: 8,
                                  padding: '8px 10px', borderRadius: 10, marginBottom: 10,
                                  background: canUseSolde ? '#f0fdf4' : '#fffbeb',
                                  border: `1px solid ${canUseSolde ? '#86efac' : '#fde68a'}`,
                                }}>
                                  <span style={{ fontSize: 14 }}>{canUseSolde ? '✅' : '⚠️'}</span>
                                  <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 11, fontWeight: 700, color: canUseSolde ? '#15803d' : '#92400e' }}>
                                      En compte — Solde : {Number(ec.solde).toLocaleString('fr-MA')} MAD
                                    </div>
                                    {soldeLow && (
                                      <div style={{
                                        marginTop: 8,
                                        padding: "8px 12px",
                                        background: "rgba(239,68,68,0.12)",
                                        border: "1.5px solid rgba(239,68,68,0.45)",
                                        borderRadius: 8,
                                        color: "#ef4444",
                                        fontWeight: 600,
                                        fontSize: 11,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                      }}>
                                        <span style={{ fontSize: 14 }}>🚫</span>
                                        <span>
                                          Votre solde{" "}
                                          <strong>({Number(ec!.solde).toLocaleString('fr-MA')} MAD)</strong>{" "}
                                          est insuffisant pour cette commande{" "}
                                          <strong>({sub.total.toLocaleString('fr-MA')} MAD requis)</strong>.
                                        </span>
                                      </div>
                                    )}
                                    {canUseSolde && (
                                      <div style={{ marginTop: 5, height: 3, borderRadius: 3, background: '#d1fae5', overflow: 'hidden' }}>
                                        <div style={{
                                          height: '100%', borderRadius: 3, background: '#16a34a',
                                          width: `${Math.min(100, (sub.total / ec.solde) * 100)}%`,
                                          transition: 'width 0.4s ease',
                                        }} />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div style={{
                                  display: 'flex', alignItems: 'center', gap: 8,
                                  padding: '7px 10px', borderRadius: 10, marginBottom: 10,
                                  background: '#f9fafb', border: '1px solid #e5e7eb',
                                }}>
                                  <span style={{ fontSize: 13 }}>ℹ️</span>
                                  <span style={{ fontSize: 11, color: '#6b7280' }}>Aucun compte ouvert avec ce fournisseur</span>
                                </div>
                              )}

                              {/* ── Premium Horizontal Payment Method Selector ── */}
                              <div className="pmm-pay-methods">

                                {/* Solde option */}
                                <button
                                  type="button"
                                  disabled={!canUseSolde}
                                  onClick={() => setSubOrders(p => p.map((o, i) => i === idx ? { ...o, paymentMethod: "solde" } : o))}
                                  className={`pmm-pay-method${isSolde ? " pmm-pay-method--active pmm-pay-method--solde" : ""}${!canUseSolde ? " pmm-pay-method--disabled" : ""}`}
                                >
                                  <div className={`pmm-pay-method__radio${isSolde ? " pmm-pay-method__radio--solde" : ""}`}>
                                    {isSolde && <div className="pmm-pay-method__dot" />}
                                  </div>
                                  <div className={`pmm-pay-method__icon${isSolde ? " pmm-pay-method__icon--solde" : ""}`}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                      <rect x="1" y="4" width="22" height="16" rx="2"/>
                                      <line x1="1" y1="10" x2="23" y2="10"/>
                                    </svg>
                                  </div>
                                  <div className="pmm-pay-method__info">
                                    <span className="pmm-pay-method__title">Payer par solde</span>
                                    <span className="pmm-pay-method__sub">
                                      {canUseSolde && ec
                                        ? `${Number(ec.solde).toLocaleString('fr-MA')} MAD dispo`
                                        : !ec?.en_compte ? 'Aucun compte' : 'Solde insuffisant'}
                                    </span>
                                  </div>
                                  {canUseSolde && <span className="pmm-pay-method__pill pmm-pay-method__pill--green">Dispo</span>}
                                </button>

                                {/* RIB option */}
                                <button
                                  type="button"
                                  onClick={() => setSubOrders(p => p.map((o, i) => i === idx ? { ...o, paymentMethod: "rib" } : o))}
                                  className={`pmm-pay-method${isRib ? " pmm-pay-method--active pmm-pay-method--rib" : ""}`}
                                >
                                  <div className={`pmm-pay-method__radio${isRib ? " pmm-pay-method__radio--rib" : ""}`}>
                                    {isRib && <div className="pmm-pay-method__dot pmm-pay-method__dot--rib" />}
                                  </div>
                                  <div className={`pmm-pay-method__icon${isRib ? " pmm-pay-method__icon--rib" : ""}`}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                      <rect x="1" y="3" width="15" height="13"/>
                                      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                                      <circle cx="5.5" cy="18.5" r="2.5"/>
                                      <circle cx="18.5" cy="18.5" r="2.5"/>
                                    </svg>
                                  </div>
                                  <div className="pmm-pay-method__info">
                                    <span className="pmm-pay-method__title">À la livraison / RIB</span>
                                    <span className="pmm-pay-method__sub">Virement ou à réception</span>
                                  </div>
                                  <span className="pmm-pay-method__pill pmm-pay-method__pill--amber">Standard</span>
                                </button>

                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>

                  {/* Total + Confirm */}
                  <div className="pmm-modal__footer">
                    {/* Recap bar */}
                    {modeLivraison === "magasin" && allMagasins.find(m => m.IdMagasin === selectedMagasinId) && (
                      <div className="pmm-modal__recap">
                        <span>📍 Retrait :</span>
                        <strong>{allMagasins.find(m => m.IdMagasin === selectedMagasinId)?.NomMagasin}</strong>
                      </div>
                    )}
                    {modeLivraison === "societe" && selectedSociete && (
                      <div className="pmm-modal__recap">
                        <span>🚚 Livraison :</span>
                        <strong>{selectedSociete.NomSociete}</strong> ({currentFrais.toFixed(2)} MAD)
                      </div>
                    )}

                    {/* Suborders breakdown if multiple */}
                    {subOrders.length > 1 && (
                      <div className="pmm-modal-recap-box">
                        {subOrders.map(sub => (
                          <div key={sub.sellerName} className="pmm-modal-recap-item">
                            <span>{sub.sellerName} &middot; {sub.paymentMethod === "solde" ? "💳 Solde" : "🏦 Livraison/RIB"}</span>
                            <strong>{sub.total.toLocaleString("fr-MA")} MAD</strong>
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="pmm-modal__total-row">
                      <span>Total à payer</span>
                      <span className="pmm-modal__total-amt">{total.toLocaleString('fr-MA')} MAD</span>
                    </div>
                    <button className="pmm-modal__btn pmm-modal__btn--confirm" onClick={handleSubmit} disabled={submitting || loadingEnCompte}>
                      {submitting ? (
                        <><span className="pm-spinner" style={{width:14,height:14,borderWidth:2,borderColor:'rgba(255,255,255,0.3)',borderTopColor:'#fff'}} /> {progressMsg}</>
                      ) : 'Confirmer la commande'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          /* ── Empty state ── */
          <div className="pmm-empty">
            <div className="pmm-empty__illustration">
              <div className="pmm-empty__circle"/>
              <svg className="pmm-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
            </div>
            <h3 className="pmm-empty__title">Votre panier est vide</h3>
            <p className="pmm-empty__desc">Parcourez notre catalogue et ajoutez des produits pour les retrouver ici.</p>
            <button className="pmm-empty__btn" onClick={handleGoBack}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5"/>
                <polyline points="12 19 5 12 12 5"/>
              </svg>
              Continuer mes achats
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default PanierMagasinMobile;
